import { useRef , useState, useEffect} from "react";
import { useNavigate } from "react-router-dom";
import EmailEditorUnlayer from "react-email-editor";
import { Button } from "@chakra-ui/react";
import { Flex } from "@chakra-ui/react";
import { Heading, Text, Box ,Select} from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { mockEmailTemplates } from "./MockEmailTemplate";


// {1. Fetch templates list
// 2. User selects template
// 3. loadDesign(design)
// 4. User edits (optional)
// 5. Export HTML
// 6. applyPayloadToHtml()}


 interface UnlayerEditor {
  editor: {
    loadDesign: (design: any) => void;
    saveDesign: (callback: (design: any) => void) => void;
    exportHtml: (callback: (data: { html: string }) => void) => void;
  };
}
// Payload Replacement
const applyPayloadToHtml = (
  html: string,
  payload?: Record<string, any>
) => {
  if (!payload || Object.keys(payload).length === 0) return html;

  let updated = html;

  Object.entries(payload).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      updated = updated.replace(
        new RegExp(`{{${key}}}`, "g"),
        String(value)
      );
    }
  });

  return updated;
};



const EmailEditor:React.FC=()=>{
    const emailEditorRef= useRef<any>(null);
    const navigate= useNavigate();
    const [templates] = useState(mockEmailTemplates);
const [selectedTemplateId, setSelectedTemplateId] = useState("");
const [editorReady, setEditorReady] = useState<boolean>(false);


  // const payload = useSelector((state: any) => state.editor?.payload ?? {});
const testPayload = {
  name: "Jyoti Duddy",
  institute: "OpenAI Academy",
  email: "jyoti@example.com",
};

    // Load saved Design 
   const onReady = () => {
  if (!emailEditorRef.current) return;
   setEditorReady(true);

  if (selectedTemplateId) {
    loadTemplateById(selectedTemplateId);
    return;
  }

  const saved = localStorage.getItem("emailDesign");
  if (saved) {
    emailEditorRef.current.editor.loadDesign(JSON.parse(saved));
  }
};


      // Save draft design
  const saveDesign = () => {
     if (!emailEditorRef.current) {
    alert("Editor not ready yet!");
    return;
  }
    emailEditorRef.current?.editor.saveDesign((design: any) => {
 console.log(design);
      alert("Email saved!");
    });
  };
  // Export final HTML
  const handleSubmit = () => {
   
     if (!emailEditorRef.current) return;

  emailEditorRef.current?.editor.exportHtml(({ html }:{html:any}) => {

      const finalHtml = applyPayloadToHtml(html, testPayload);


      navigate("/email-preview",{
        state:{html:finalHtml},
      });

    })

  };
  const loadTemplateById = (templateId: string) => {
    if (!editorReady || !emailEditorRef.current?.editor) return;
  const template = templates.find(t => t.id === templateId);
 
  if (!template) return;

  if (emailEditorRef.current) {
    emailEditorRef.current.editor.loadDesign(template.design);
  }
};

  // Move first row to bottom
  const moveDown = () => {
    emailEditorRef.current?.editor.saveDesign((design: any) => {
      const rows = design.body.rows;
      const first = rows.shift();
      if (first) rows.push(first);
      emailEditorRef.current?.editor.loadDesign(design);
    });
  };

  // Move last row to top
  const moveUp = () => {
    emailEditorRef.current?.editor.saveDesign((design: any) => {
      const rows = design.body.rows;
      const last = rows.pop();
      if (last) rows.unshift(last);
      emailEditorRef.current?.editor.loadDesign(design);
    });
  };

  // Swap rows
  const swapRows = (a: number, b: number) => {
    emailEditorRef.current?.editor.saveDesign((design: any) => {
      const rows = design.body.rows;
      [rows[a], rows[b]] = [rows[b], rows[a]];
      emailEditorRef.current?.editor.loadDesign(design);
    });
  };
   useEffect(() => {
  if (editorReady && selectedTemplateId) {
    loadTemplateById(selectedTemplateId);
  }
}, [editorReady, selectedTemplateId]);
useEffect(() => {
  if (editorReady && selectedTemplateId) {
    const template = templates.find(t => t.id === selectedTemplateId);
    if (template && emailEditorRef.current?.editor) {
      emailEditorRef.current.editor.loadDesign(template.design);
    }
  }
}, [editorReady, selectedTemplateId, templates]);


    return(
  <Box h="90vh" display="flex" flexDirection="column" overflow="hidden">
      <Box textAlign="center" py={4} px={4}>
  <Heading size="lg" mb={1}>
    Design Your Email
  </Heading>
  <Text fontSize="sm" color="gray.500">
    Build, rearrange, and preview your email layout
  </Text>
</Box>


      {/* <div style={{ height: "80vh" }}>
        <EmailEditorUnlayer ref={emailEditorRef} onReady={onReady} />
      </div> */
        <Box flex="1" minH="0" overflow="hidden">
          <Box px={4} mb={3}>
  <Select
    placeholder="Select Email Template"
    value={selectedTemplateId}
    onChange={(e) => {
      const id = e.target.value;
      setSelectedTemplateId(id);
      if(editorReady){
    loadTemplateById(id);
      }
      
    }}
  >
    {templates.map(template => (
      <option key={template.id} value={template.id}>
        {template.name}
      </option>
    ))}
  </Select>
</Box>

    <EmailEditorUnlayer ref={emailEditorRef} onReady={onReady} options={{
    mergeTags: {
      name: {
        name: "Name",
        value: "{{name}}",
      },
      email: {
        name: "Email",
        value: "{{email}}",
      },
      institute: {
        name: "Institute",
        value: "{{institute}}",
      },
    },
  }}/>
  </Box>
}


      <Flex
  direction={{ base: "row", md: "row" }}
  gap={3}
   justify="center"
  align="center"
  wrap="wrap"   px={{ base: 2, md: 4 }}
  py={4}
>
  <Button
  w={{ base: "100%", sm: "48%", md: "auto" }}
     size="md" 
  px={6}          // padding left & right
  py={3}          // padding top & bottom
  fontSize="sm"
  fontWeight="600"
  boxShadow="0 4px 15px -3px rgba(59, 130, 246, 0.4)"
  transition="all 0.3s ease"
  _hover={{
    bgGradient: "linear(to-br, blue.500, blue.700)",
    boxShadow: "0 8px 25px -5px rgba(59, 130, 246, 0.5)",
    transform: "translateY(-2px)",
  }}
  _active={{
    transform: "translateY(0)",
    boxShadow: "0 4px 12px -3px rgba(59, 130, 246, 0.4)",
  }}
    onClick={saveDesign}
    color="white"
    borderRadius="xl"
    bgGradient="linear(to-br, blue.400, blue.600)"
  >
    Save Draft
  </Button>

  <Button
    w={{ base: "100%", sm: "48%", md: "auto" }}
     size="md"
  px={6}          // padding left & right
  py={3}          // padding top & bottom
  fontSize="sm"
  fontWeight="600"
  boxShadow="0 4px 15px -3px rgba(59, 130, 246, 0.4)"
  transition="all 0.3s ease"
  _hover={{
    bgGradient: "linear(to-br, blue.500, blue.700)",
    boxShadow: "0 8px 25px -5px rgba(59, 130, 246, 0.5)",
    transform: "translateY(-2px)",
  }}
  _active={{
    transform: "translateY(0)",
    boxShadow: "0 4px 12px -3px rgba(59, 130, 246, 0.4)",
  }}
    onClick={moveDown}
    color="white"
    borderRadius="xl"
    bgGradient="linear(to-br, blue.400, blue.600)"
  >
    Push First Block Down
  </Button>

  <Button
 w={{ base: "100%", sm: "48%", md: "auto" }}
     size="md"
  px={6}          // padding left & right
  py={3}          // padding top & bottom
  fontSize="sm"
  fontWeight="600"
  boxShadow="0 4px 15px -3px rgba(59, 130, 246, 0.4)"
  transition="all 0.3s ease"
  _hover={{
    bgGradient: "linear(to-br, blue.500, blue.700)",
    boxShadow: "0 8px 25px -5px rgba(59, 130, 246, 0.5)",
    transform: "translateY(-2px)",
  }}
  _active={{
    transform: "translateY(0)",
    boxShadow: "0 4px 12px -3px rgba(59, 130, 246, 0.4)",
  }}
    onClick={()=>swapRows(0,1)}
    color="white"
    borderRadius="xl"
    bgGradient="linear(to-br, blue.400, blue.600)"
  >
    Swap 1st & 2nd
  </Button>

  <Button
     w={{ base: "100%", sm: "48%", md: "auto" }}
     size="md"
  px={6}          // padding left & right
  py={3}          // padding top & bottom
  fontSize="sm"
  fontWeight="600"
  boxShadow="0 4px 15px -3px rgba(59, 130, 246, 0.4)"
  transition="all 0.3s ease"
  _hover={{
    bgGradient: "linear(to-br, blue.500, blue.700)",
    boxShadow: "0 8px 25px -5px rgba(59, 130, 246, 0.5)",
    transform: "translateY(-2px)",
  }}
  _active={{
    transform: "translateY(0)",
    boxShadow: "0 4px 12px -3px rgba(59, 130, 246, 0.4)",
  }}
    onClick={moveUp}
    color="white"
    borderRadius="xl"
    bgGradient="linear(to-br, blue.400, blue.600)"
  >
    Push Last Block Up
  </Button>

  <Button
      w={{ base: "100%", sm: "48%", md: "auto" }}
    onClick={handleSubmit}
    color="white"
    borderRadius="xl"
    bgGradient="linear(to-br, green.400, green.600)"
        size="md"
  px={6}          // padding left & right
  py={3}          // padding top & bottom
  fontSize="sm"
  fontWeight="600"
  boxShadow="0 4px 15px -3px rgba(29, 146, 101, 0.4)"
transition="all 0.3s ease"
  _hover={{
    bgGradient: "linear(to-br, blue.500, blue.700)",
    boxShadow: "0 8px 25px -5px rgba(29, 146, 101, 0.4))",
    transform: "translateY(-2px)",
  }}
  _active={{
    transform: "translateY(0)",
    boxShadow: "0 4px 12px -3px rgba(29, 146, 101, 0.4)",
  }}
   
  >
    Submit & Preview
  </Button>
</Flex>

  </Box>

    )
}
export default EmailEditor;


